import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { MapContainer as Map, Marker } from 'react-leaflet';
import BaseMapLayer from '../../../../components/molecules/Map/BaseMapLayer';
import './ServiceDialog.scss';

const ServiceDialog = ({
                           visible,
                           onHide,
                           formData,
                           handleInputChange,
                           handleSubmit,
                           handleReset,
                           tiposServicio,
                           proveedores,
                           unidades,
                           operadorInfo,
                           selectedProveedor,
                           setSelectedProveedor,
                           loading,
                           formatearFechaHora,
                           combineDateAndTime,
                           inicioDeHoy,
                           esMismoDia,
                           DEFAULT_CENTER,
                           MapFlyToProveedor
                       }) => {
    // Mínimo para los selectores de hora: si la fecha de bitácora es hoy,
    // no se permite elegir una hora que ya pasó.
    const minHoraEntrada =
        formData.fechaBitacora && esMismoDia(new Date(formData.fechaBitacora), new Date())
            ? new Date()
            : undefined;
    return (
        <Dialog
            header="Registro de Servicio de Taller"
            visible={visible}
            onHide={onHide}
            style={{ width: '90vw', maxWidth: '1200px' }}
            className="taller-service-dialog"
            modal
            dismissableMask
        >
            <div className="taller-dialog-container">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}>
                    <div className="form-grid-taller">
                        <div>
                            <div className="field-container">
                                <label className="field-label-taller">
                                    Fecha de Bitácora *
                                </label>
                                <Calendar
                                    value={formData.fechaBitacora ? new Date(formData.fechaBitacora) : null}
                                    onChange={(e) =>
                                        handleInputChange('fechaBitacora', formatearFechaHora(e.value))
                                    }
                                    minDate={inicioDeHoy}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    className="form-input"
                                    required
                                />
                            </div>

                            <div className="field-container">
                                <label className="field-label-taller">
                                    Tipo de Servicio *
                                </label>
                                <Dropdown
                                    value={formData.tipo}
                                    options={tiposServicio}
                                    onChange={(e) => handleInputChange('tipo', e.value)}
                                    placeholder="Seleccione el tipo de servicio"
                                    className="form-input"
                                    filter
                                    required
                                />
                            </div>
                        </div>
                        <div>
                            <div className="time-grid">
                                <div>
                                    <label className="field-label-taller">
                                        Hora Entrada *
                                    </label>
                                    <Calendar
                                        value={formData.horaEntrada ? new Date(formData.horaEntrada) : null}
                                        onChange={(e) => {
                                            const combined = combineDateAndTime(
                                                formData.fechaBitacora ? new Date(formData.fechaBitacora) : new Date(),
                                                e.value
                                            );
                                            handleInputChange('horaEntrada', formatearFechaHora(combined));
                                        }}
                                        timeOnly
                                        hourFormat="24"
                                        showIcon
                                        className="form-input"
                                        style={{width: '100%'}}
                                        minDate={minHoraEntrada}
                                        disabled={!formData.fechaBitacora}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="field-label-taller">
                                        Hora Salida *
                                    </label>
                                    <Calendar
                                        value={formData.horaSalida ? new Date(formData.horaSalida) : null}
                                        onChange={(e) => {
                                            const combined = combineDateAndTime(
                                                formData.fechaBitacora ? new Date(formData.fechaBitacora) : new Date(),
                                                e.value
                                            );
                                            handleInputChange('horaSalida', formatearFechaHora(combined));
                                        }}
                                        timeOnly
                                        hourFormat="24"
                                        showIcon
                                        className="form-input"
                                        style={{width: '100%'}}
                                        minDate={
                                            formData.horaEntrada
                                                ? new Date(formData.horaEntrada)
                                                : minHoraEntrada
                                        }
                                        disabled={!formData.fechaBitacora}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="field-container">
                                <label className="field-label-taller">
                                    Proveedor de Taller *
                                </label>
                                <Dropdown
                                    value={formData.proveedorTaller}
                                    options={proveedores}
                                    onChange={(e) => {
                                        handleInputChange('proveedorTaller', e.value);
                                        const proveedorCompleto = proveedores.find(p => p.value === e.value);
                                        setSelectedProveedor(proveedorCompleto);
                                    }}
                                    placeholder="Seleccione el proveedor"
                                    className="form-input"
                                    filter
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-grid-taller">
                        <div>
                            <div className="field-container">
                                <label className="field-label-taller">
                                    Unidad *
                                </label>
                                <Dropdown
                                    value={formData.unidad}
                                    options={unidades}
                                    onChange={(e) => handleInputChange('unidad', e.value)}
                                    placeholder="Seleccione la unidad"
                                    className="form-input"
                                    filter
                                    required
                                />
                            </div>

                            {operadorInfo.nombre && (
                                <div className="operator-info">
                                    <h4 className="operator-title">
                                        Información del Operador
                                    </h4>
                                    <p className="operator-detail">
                                        <strong>Nombre:</strong> {operadorInfo.nombre}
                                    </p>
                                    <p className="operator-detail">
                                        <strong>Teléfono:</strong> {operadorInfo.telefono}
                                    </p>
                                </div>
                            )}
                        </div>

                        <div>
                            <div className="field-container">
                                <label className="field-label-taller">
                                    Nota
                                </label>
                                <InputTextarea
                                    value={formData.nota}
                                    onChange={(e) => handleInputChange('nota', e.target.value)}
                                    placeholder="Notas adicionales..."
                                    rows={3}
                                    className="form-textarea"
                                    pt={{
                                        root: {className: 'textarea-root'}
                                    }}
                                />
                            </div>

                            <div className="button-container-taller">
                                <Button
                                    label="Guardar Servicio"
                                    icon="pi pi-save"
                                    type="submit"
                                    className="btn-save"
                                    severity="success"
                                    loading={loading}
                                />
                                <Button
                                    label="Limpiar Formulario"
                                    icon="pi pi-refresh"
                                    onClick={handleReset}
                                    className="btn-reset"
                                    severity="secondary"
                                    type="button"
                                />
                            </div>
                        </div>
                    </div>
                </form>

                <Divider/>

                <div className="map-section">
                    <h3 className="section-title">
                        Mapa de Ubicación del Taller
                    </h3>
                    <div className="map-placeholder">
                        <Map
                            center={DEFAULT_CENTER}
                            zoom={10}
                            scrollWheelZoom={true}
                            style={{width: '100%', height: '30rem', zIndex: "0"}}
                        >
                            <BaseMapLayer />
                            {selectedProveedor?.lat && selectedProveedor?.lng && (
                                <>
                                    <Marker position={[selectedProveedor.lat, selectedProveedor.lng]}/>
                                    <MapFlyToProveedor lat={selectedProveedor.lat} lng={selectedProveedor.lng}/>
                                </>
                            )}
                        </Map>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ServiceDialog;